const projects = [
  {
    id: 1,
    title: 'Rinnai Multi-Split Installation',
    category: 'AC Installation',
    location: 'Residential – Brick Home',
    image: 'https://static.readdy.ai/image/a5f7b01a6336ee677dff5ed9eebc172a/12cb3a4c75ffc39e0ca9a779811a2df3.jpeg',
  },
  {
    id: 2,
    title: 'Split System Wall Mount',
    category: 'AC Installation',
    location: 'Residential – Living Room',
    image: 'https://public.readdy.ai/ai/img_res/c57bc69e55260f5381c85c9849441087.jpg',
  },
  {
    id: 3,
    title: 'Ducted System Replacement',
    category: 'Ducted Heating',
    location: 'Residential – Full Home',
    image: 'https://readdy.ai/api/search-image?query=hvac-technician-installing-ducted-heating-and-cooling-system-in-Australian-residential-home-roof-space-ductwork-visible-professional-tools-clean-installation-bright-attic-space-high-quality-photo&width=800&height=600&seq=ourwork-ducted-1&orientation=landscape',
  },
  {
    id: 4,
    title: 'Outdoor Unit Stacked Setup',
    category: 'AC Installation',
    location: 'Residential – Side of House',
    image: 'https://readdy.ai/api/search-image?query=two-stacked-outdoor-air-conditioning-condenser-units-mounted-neatly-on-concrete-pad-beside-brick-wall-Australian-residential-home-tidy-pipework-and-cable-conduit-clean-professional-installation-sunny-day&width=800&height=600&seq=ourwork-outdoor-stack-1&orientation=landscape',
  },
  {
    id: 5,
    title: 'Gas Heating Service',
    category: 'Heating Repair',
    location: 'Residential – Melbourne',
    image: 'https://readdy.ai/api/search-image?query=professional-hvac-technician-servicing-gas-ducted-heater-unit-in-Australian-residential-home-open-panel-with-tools-nearby-clean-white-heater-unit-indoor-bright-lighting-high-quality-service-photo&width=800&height=600&seq=ourwork-gas-heat-1&orientation=landscape',
  },
  {
    id: 6,
    title: 'Ceiling Cassette Install',
    category: 'Commercial',
    location: 'Small Office – Melbourne',
    image: 'https://readdy.ai/api/search-image?query=ceiling-cassette-air-conditioner-unit-freshly-installed-in-commercial-office-space-clean-white-ceiling-tiles-modern-interior-professional-hvac-installation-bright-daylight-high-quality-photography&width=800&height=600&seq=ourwork-cassette-1&orientation=landscape',
  },
];

const categoryColors: Record<string, string> = {
  'AC Installation': 'bg-teal-100 text-teal-700',
  'Ducted Heating': 'bg-orange-100 text-orange-700',
  'Heating Repair': 'bg-red-100 text-red-700',
  'Commercial': 'bg-gray-200 text-gray-700',
};

export default function OurWork() {
  return (
    <section id="our-work" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <p className="text-xs uppercase tracking-wider text-gray-500 mb-2">RECENT PROJECTS</p>
          <h2 className="text-4xl md:text-5xl font-serif text-gray-900">Our Work</h2>
          <p className="mt-4 text-gray-500 max-w-xl text-sm leading-relaxed">
            A look at some of our recent HVAC installations and repairs across Melbourne. Every job is completed to the highest standard.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <div
              key={project.id}
              className="rounded-2xl overflow-hidden group cursor-pointer"
              style={{ border: '1px solid #f0f0f0' }}
            >
              <div className="w-full h-56 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 bg-white">
                <span
                  className={`text-xs font-semibold px-3 py-1 rounded-full ${categoryColors[project.category] ?? 'bg-gray-100 text-gray-600'}`}
                >
                  {project.category}
                </span>
                <h3 className="mt-3 text-base font-bold text-gray-900">{project.title}</h3>
                <p className="mt-1 text-xs text-gray-400 flex items-center gap-1">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-map-pin-2-line"></i>
                  </span>
                  {project.location}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
